import { Navigate, type RouteObject } from "react-router";

import { DASHBOARD_TRIGGERS_LINK } from "@application/navigation/dashboard_triggers_link";

import { DASHBOARD_TRIGGERS_MAILBOXES_ROUTE } from "./mailboxes/route";
import { DASHBOARD_TRIGGERS_SCHEDULES_ROUTE } from "./schedules/route";
import { DASHBOARD_TRIGGERS_WEBHOOKS_ROUTE } from "./webhooks/route";

export const DASHBOARD_TRIGGERS_ROUTE = {
  path: "triggers",
  handle: DASHBOARD_TRIGGERS_LINK,
  children: [
    DASHBOARD_TRIGGERS_MAILBOXES_ROUTE,
    DASHBOARD_TRIGGERS_SCHEDULES_ROUTE,
    DASHBOARD_TRIGGERS_WEBHOOKS_ROUTE,
    {
      index: true,
      element: <Navigate to="/dashboard/triggers/webhooks" replace />,
    },
  ],
} satisfies RouteObject;
